import React, { useState, useEffect } from 'react';
import { Redirect } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import LoginTemplate from 'components/templates/Login';
import LoginService from 'services/Login';
import { getStorage } from 'store';
import { useAuth } from "context";
import CompanyService from 'services/company.service';
import pino from 'pino';

// The SDK logger uses Node async context; this SPA needs Pino's browser entry.
// https://github.com/pinojs/pino/blob/v10.3.1/docs/browser.md
const logger = pino({ browser: { asObject: true } });

const LoginPage = props => {

  const [isLoggedIn, setLoggedIn] = useState(false);
  const [isError, setIsError] = useState(false);
  const { setAuth, auth } = useAuth();

  useEffect(() => {
    if (auth && (!(auth || {}).company)) {
      fetchCompany();
    }
  }, [auth])

  const fetchCompany = async () => {
    try {
      const { data } = await CompanyService.find();
      setAuth({ ...auth, company: data });
    } catch (error) {
      // Allowlisted fields only: Axios errors/responses can contain bearer tokens.
      logger.error({ event: 'company_profile_fetch_failed', status: error?.status ?? null });
    }
  }

  async function doSignIn(data) {
    debugger
    const res = await LoginService.signIn(data);
    debugger
    const auth = res.data?.data || {};
    if (res.status === 200) {
      const decodedToken = jwtDecode(auth.token);
      debugger
      setAuth({
        expires: auth.expires,
        token: auth.token,
        exp: decodedToken.exp,
        orig_iat: decodedToken.orig_iat,
        ...decodedToken
      });
      setLoggedIn(true);
    } else {
      setIsError(true);
      setTimeout(() => {
        setIsError(false);
      }, 3000);
    }
  }

  if (getStorage() || isLoggedIn) {
    return <Redirect to="/" />
  }

  return (
    <LoginTemplate
      formSubmitHandler={doSignIn}
      formSubmitError={isError}
    />
  );
}

export default LoginPage;